import React from 'react';
import injectStores from '../RootStore/injectStores';
// import type { RouterStore } from 'stores/RouterStore';
// import type ScheduleGridStore from 'stores/ScheduleGridStore/ScheduleGridStore';
import { ScheduleGridHeaderCellProps } from './ScheduleGrid.Types';

const styles = {
  display: 'flex',
  alignItems: 'center',
  border: '1px solid #eee',
  padding: '0px',
  justifyContent: 'center',
  flexDirection: 'column',
};

export const RightHeaderCell: React.FC<ScheduleGridHeaderCellProps> =
  injectStores((props: ScheduleGridHeaderCellProps) => {
    const {
      namespaceId = '',
      style,
      columnIndex,
      rowIndex,
      scheduleGridStore,
    } = props;
    const currentStore = scheduleGridStore?.namespaces[namespaceId];
    // console.log('currentStore', currentStore);
    const currentHeader = currentStore?.currentColumnHeaders?.[columnIndex];

    if (currentHeader?.component) {
      const Component = currentHeader.component;
      // console.log('RightHeaderCell Component', Component);
      return React.cloneElement(<Component />, {
        currentStore,
        currentHeader,
        styles,
        ...props,
      });
    }
    return (
      <div
        key={`right-header-cell-${namespaceId}-${rowIndex}`}
        title={undefined}
        style={{
          ...style,
          ...styles,
          height: (typeof style?.height === 'number' ? style.height : 0) - 2,
          width: (typeof style?.width === 'number' ? style.width : 0) - 2,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'flex-start',
        }}
      >
        {currentHeader && <b>{currentHeader.title}</b>}
      </div>
    );
  });

export default RightHeaderCell;
